<template>
  <v-expansion-panels v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header class="px-2 dark--text font-weight-medium collapse-bar text-sm">
        Upcoming & Overdue
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-card-text class="py-0">
          <v-timeline align-top dense>
            <v-timeline-item
              v-for="(task, index) in itemTask"
              :key="index"
              :color="task.workflow_status ? task.workflow_status.colour : '#fe724c'"
              small
            >
              <v-row class="pt-1">
                <v-col cols="12">
                  <div class="d-flex justify-space-between">
                    <div class="text-link mr-5" @click="handleTaskClick(task.uuid)">
                      {{ task.name }}
                    </div>
                  </div>
                  <span class="text-xs dark--text">
                    <span v-for="(user, i) in task.assigned_users" :key="user.uuid">
                      {{ user.name }}
                      <span v-if="i + 1 !== task.assigned_users.length">, </span>
                    </span>
                    have an upcoming task</span
                  >
                  <span v-if="task.contact_detail && task.contact_detail.uuid" class="text-xs">
                    with

                    <v-tooltip top content-class="log-tooltip">
                      <template v-slot:activator="{ on, attrs }">
                        <span
                          v-if="task.contact_detail && task.contact_detail.uuid"
                          v-bind="attrs"
                          class="info--text"
                          v-on="on"
                          >{{ task.contact_detail.name }}</span
                        >
                      </template>
                      <div>
                        <h3 class="mb-2">{{ task.contact_detail.name }}</h3>

                        <div class="d-flex mb-1">
                          <p class="mb-0">Email -</p>
                          <p class="mb-0">{{ task.contact_detail.email }}</p>
                        </div>
                        <div class="d-flex">
                          <p class="mb-0">Phone -</p>
                          <p class="mb-0">{{ task.contact_detail.phone }}</p>
                        </div>
                      </div>
                    </v-tooltip>
                  </span>

                  <span
                    v-if="task.related_to && $route.params.uuid !== task.related_to.uuid"
                    class="text-xs"
                    @click="handleRedirect(task)"
                  >
                    about <span class="text-link">{{ task.related_to.name }}</span>
                  </span>

                  <div class="d-flex align-center">
                    <v-icon
                      v-if="isVisibleId !== task.uuid"
                      @click=";(isVisible = true), (isVisibleId = task.uuid)"
                    >
                      {{ icons.mdiChevronRight }}
                    </v-icon>
                    <v-icon
                      v-if="isVisibleId === task.uuid"
                      @click=";(isVisible = false), (isVisibleId = null)"
                    >
                      {{ icons.mdiChevronDown }}
                    </v-icon>
                    <p class="mb-0 ml-2 text-xs2 text--primary">
                      <span class="text-xs dark--text">{{ formatDate(task.due_date) }}</span>
                    </p>
                  </div>

                  <div v-if="isVisible && task.uuid === isVisibleId" class="log-card mt-2">
                    <p class="dark--text text-sm mb-1" style="white-space: pre-wrap">
                      {{ task.details }}
                    </p>
                  </div>
                </v-col>
              </v-row>
            </v-timeline-item>
          </v-timeline>
        </v-card-text>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { useRouter } from '@core/utils'
import { watch, ref, onUnmounted, onMounted } from '@vue/composition-api'
import { formatDate } from '@core/utils/filter'
import store from '@/store'
import { storeActions } from '@/store/storeConstants'
import { mdiChevronRight, mdiChevronDown } from '@mdi/js'
import eventBus from '@/@core/utils/eventBus'
import { isCrmSection, getRouteView } from '@core/utils/common'
import useTabService from '@/@core/comp-functions/useTabService'

export default {
  components: {},
  props: {
    propType: {
      type: String,
      required: true,
    },
    propId: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    const { router } = useRouter()
    const viewTaskModal = ref(false)
    const modalForm = ref({})
    const panel = ref(null)
    const response = ref([])
    const itemTask = ref([])
    const loading = ref(false)
    const page = ref(1)
    const isVisible = ref(false)
    const isVisibleId = ref(null)
    const dateFilter = ref('all')
    const sortValue = ref('desc')

    const { gotoCrmTab } = useTabService()

    const loadMore = () => {
      page.value = 1
      const payload = {
        component: 'task-management/spaces/item/module/list',
        object: {
          prop_id: props.propId,
          prop_type: props.propType,
          filter: {
            workflow_stage: [0, 2, 3],
          },
          sort: sortValue.value,
          sortby: 'updatedAt',
          date_filter: dateFilter.value === 'all' ? undefined : dateFilter.value,
        },
      }

      store.dispatch(`common/${storeActions.CREATE}`, payload).then(({ data }) => {
        if (data.success) {
          itemTask.value = data.data
          response.value = itemTask.value.slice(0, 10)
        }
      })
    }

    watch(
      () => ctx.root.$route,
      () => {
        loadMore()
      },
      { immediate: true },
    )

    const handleTaskClick = uuid => {
      store.commit('taskManagement/SET_TASKBAR_ID', uuid)
      store.commit('taskManagement/SET_OPEN_BAR', true)
      store.commit('fieldManagement/SET_FIELD_ACTIVITY_BAR', false)
    }

    const infiniteScrolling = () => {
      if (panel.value !== 0) return
      if (page.value * 10 < itemTask.value.length) {
        page.value += 1

        const nextItems = itemTask.value.slice(10 * (page.value - 1), 10)

        response.value.push([...nextItems])
      }
    }

    const upcomingTaskFetch = () => {
      ctx.emit('taskFetch')
      loadMore()
    }

    onMounted(() => {
      eventBus.$on('onTaskUpdate', () => {
        ctx.emit('taskFetch')
        loadMore()
      })
    })

    onUnmounted(() => {
      eventBus.$off('onTaskUpdate')
    })

    const handleRedirect = item => {
      const payload = {
        paramName: 'uuid',
        name: item.related_to.name,
        uuid: item.related_to.uuid,
      }

      if (isCrmSection(item.related_type)) {
        gotoCrmTab(payload, getRouteView(item.related_type))

        router.push({ name: getRouteView(item.related_type), params: { uuid: payload.uuid } })
      }
    }

    return {
      loading,
      response,
      loadMore,
      sortValue,
      upcomingTaskFetch,
      formatDate,
      panel,
      handleRedirect,
      viewTaskModal,
      infiniteScrolling,
      modalForm,
      handleTaskClick,
      isVisible,
      isVisibleId,
      itemTask,
      dateFilter,
      icons: {
        mdiChevronRight,
        mdiChevronDown,
      },
    }
  },
}
</script>

<style scoped>
.collapse-bar {
  background: #eee;
  min-height: 48px !important;
}
</style>
